import { render } from "./productSupplierStatistics.vue?vue&type=template&id=308ce4c9"
import script from "./productSupplierStatistics.vue?vue&type=script&lang=js"
export * from "./productSupplierStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/purchase/components/productSupplierStatistics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "308ce4c9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('308ce4c9', __exports__)) {
    api.reload('308ce4c9', __exports__)
  }
  
  module.hot.accept("./productSupplierStatistics.vue?vue&type=template&id=308ce4c9", () => {
    api.rerender('308ce4c9', render)
  })

}


export default __exports__